// Module
var code = `<!-- clExternal — embedded third-party content (StackBlitz, code playgrounds, etc.).
     Data shape: { externalType, externalId, title, subtitle?, openFile?, footer? }

     This template renders the outer wrapper; the actual embed (iframe, playground mount)
     is handled by the existing SpyneJS external-content integration, keyed by
     data-external-type and data-external-id on the __mount element. -->
<div class="block-cl-external block-cl-external--{{externalType}}">
  <header class="block-cl-external__header">
    <div class="block-cl-external__title">{{title}}</div>
    {{#subtitle}}<div class="block-cl-external__subtitle">{{subtitle}}</div>{{/subtitle}}
  </header>
  <div
    class="block-cl-external__mount"
    data-external-type="{{externalType}}"
    data-external-id="{{externalId}}"
    {{#openFile}}data-open-file="{{openFile}}"{{/openFile}}
  ></div>
  {{#footer}}<footer class="block-cl-external__footer">{{footer}}</footer>{{/footer}}
</div>
`;
// Exports
module.exports = code;